export default {
  "tag": "li",
  "data-id": "${_id}",
  "html": "${name}",
  "children": [{
    "tag": "strong",
    "html": " ${code}"
  }]
};



// WEBPACK FOOTER //
// ./public/scripts/webpack/template.js